import EmblaCarousel from "embla-carousel";
import { initEmblaProgress } from "@theme/critical";

function initCarousel(carousels) {
  carousels.forEach((carousel) => {
    const viewportNode = carousel.querySelector(".embla__viewport");
    const emblaApi = EmblaCarousel(viewportNode, {
      loop: false,
      align: "start"
    });
    initEmblaProgress(carousel, emblaApi);
  });
}

function initSections() {
  const carousels = document.querySelectorAll(".banner-carousel");
  initCarousel(carousels);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSections, { once: true });
} else {
  initSections();
}

document.addEventListener("shopify:section:load", function (event) {
  if (
    event.target instanceof HTMLElement
  ) {
    const carousels = event.target.querySelectorAll(".banner-carousel");
    if(carousels.length > 0) {
      initCarousel(carousels);
    }
  }
})
